import { useEffect, useState, useCallback } from 'react';

/**
 * useCasesRefreshInterval — User-Preference für Cases-Liste Auto-Refresh.
 *
 * #1247 — Refresh-Intervall raus aus Cases-Liste, in /cases/einstellungen verschoben.
 * localStorage-MVP (keine User-Preference-Infrastructure vorhanden).
 *
 * Werte: 30000 (30s), 60000 (1min, Default), 300000 (5min), 0 (aus / manuell).
 *
 * Cross-Tab-Sync via `storage`-Event — Settings-Page-Änderung wird in offener
 * Cases-Liste anderer Tabs übernommen.
 */
const STORAGE_KEY = 'cases.refresh_interval_seconds';
const DEFAULT_SECONDS = 60;
const ALLOWED_SECONDS = [0, 30, 60, 300];

export function readCasesRefreshSeconds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return DEFAULT_SECONDS;
    const n = Number(raw);
    if (!Number.isFinite(n) || !ALLOWED_SECONDS.includes(n)) return DEFAULT_SECONDS;
    return n;
  } catch {
    return DEFAULT_SECONDS;
  }
}

export function writeCasesRefreshSeconds(seconds) {
  const n = Number(seconds);
  if (!ALLOWED_SECONDS.includes(n)) return;
  try {
    localStorage.setItem(STORAGE_KEY, String(n));
  } catch { /* quota / private mode — ignore */ }
}

export default function useCasesRefreshInterval() {
  const [seconds, setSecondsState] = useState(readCasesRefreshSeconds);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setSecondsState(readCasesRefreshSeconds());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setSeconds = useCallback((value) => {
    writeCasesRefreshSeconds(value);
    setSecondsState(Number(value));
  }, []);

  return [seconds, setSeconds];
}
